__turbopack_context__.v({
  "contact-details": "CoreLocationDetails-module-scss-module__Y-T3SG__contact-details",
  "contact-information": "CoreLocationDetails-module-scss-module__Y-T3SG__contact-information",
  "contact-name": "CoreLocationDetails-module-scss-module__Y-T3SG__contact-name",
  "email": "CoreLocationDetails-module-scss-module__Y-T3SG__email",
  "number-address": "CoreLocationDetails-module-scss-module__Y-T3SG__number-address",
  "office-contact": "CoreLocationDetails-module-scss-module__Y-T3SG__office-contact",
  "subhead": "CoreLocationDetails-module-scss-module__Y-T3SG__subhead",
  "subhead-block": "CoreLocationDetails-module-scss-module__Y-T3SG__subhead-block",
  "value": "CoreLocationDetails-module-scss-module__Y-T3SG__value",
});
